import React from 'react';

import { Box } from '@mui/material';

import { TranslationKeys } from 'app/translations';
import { ActionButton, CustomBreadcrumb } from 'app/components';
import { RATE_TABLE_FORM_ID } from 'app/Domain/Settings/Components';

type SettingsRateTableCreateToolbarProps = {
  isLoading?: boolean;
};

export const SettingsRateTableCreateToolbar = ({ isLoading = false }: SettingsRateTableCreateToolbarProps) => {
  const breadcrumbItems = React.useMemo(() => {
    return [
      {
        title: TranslationKeys.global_createNew,
      },
      {
        title: TranslationKeys.menu_settings_rateTables,
        href: '/settings/rate-tables',
      },
    ];
  }, []);

  return (
    <Box paddingTop={2} display={'flex'} justifyContent={'space-between'}>
      <CustomBreadcrumb items={breadcrumbItems} />
      <ActionButton
        messageId={TranslationKeys.button_create}
        type={'submit'}
        form={RATE_TABLE_FORM_ID}
        disabled={isLoading}
      />
    </Box>
  );
};
